import template from './timesheet-report.html';
import controller from './timesheet-report.controller';

let timesheetReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default timesheetReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/timesheet-report/timesheet-report.component.js